var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPartD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_10853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0434 0C15.1854 0 13.4388 0.723538 12.1246 2.03774L2.03774 12.1246C0.723538 13.4384 0 15.1854 0 17.0434C0 20.8792 3.12078 24 6.95659 24C8.81458 24 10.5612 23.2765 11.8754 21.9623L21.9626 11.8749C23.2765 10.5616 24 8.81458 24 6.95659C24 3.12078 20.8792 0 17.0434 0ZM11.3281 21.4149C10.1602 22.5828 8.60742 23.2258 6.95659 23.2258C3.54738 23.2258 0.774194 20.4522 0.774194 17.0434C0.774194 15.3922 1.41721 13.8398 2.58512 12.6719L7.35484 7.90222L16.0978 16.6452L11.3281 21.4149ZM21.4149 11.3281L16.6452 16.0978L7.90222 7.35484L12.6719 2.58512C13.8398 1.41721 15.3926 0.774194 17.0434 0.774194C20.4526 0.774194 23.2258 3.54776 23.2258 6.95659C23.2258 8.60742 22.5828 10.1602 21.4149 11.3281Z",
    fill: "#00738F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8951 3.10498L20.3477 3.65236C21.2051 4.50972 21.6774 5.65022 21.6774 6.86254C21.6774 8.07486 21.2051 9.21536 20.3477 10.0727L16.3715 14.049L16.9188 14.5963L20.8951 10.6201C21.8987 9.61626 22.4516 8.28202 22.4516 6.86254C22.4516 5.44306 21.8987 4.10863 20.8951 3.10498Z",
    fill: "#00738F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2581 17.8064C3.40415 17.8064 2.70972 18.5008 2.70972 19.3548C2.70972 20.2087 3.40415 20.9032 4.2581 20.9032C5.11206 20.9032 5.80649 20.2087 5.80649 19.3548C5.80649 18.5008 5.11206 17.8064 4.2581 17.8064ZM4.2581 20.129C3.83113 20.129 3.48391 19.7818 3.48391 19.3548C3.48391 18.9278 3.83113 18.5806 4.2581 18.5806C4.68508 18.5806 5.0323 18.9278 5.0323 19.3548C5.0323 19.7818 4.68508 20.129 4.2581 20.129Z",
    fill: "#00738F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0323 12.3872C3.75136 12.3872 2.70972 13.4289 2.70972 14.7098C2.70972 15.9907 3.75136 17.0324 5.0323 17.0324C6.31323 17.0324 7.35488 15.9907 7.35488 14.7098C7.35488 13.4289 6.31323 12.3872 5.0323 12.3872ZM5.0323 16.2582C4.17834 16.2582 3.48391 15.5637 3.48391 14.7098C3.48391 13.8558 4.17834 13.1614 5.0323 13.1614C5.88625 13.1614 6.58068 13.8558 6.58068 14.7098C6.58068 15.5637 5.88625 16.2582 5.0323 16.2582Z",
    fill: "#00738F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_10853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPartD);
export default __webpack_public_path__ + "static/media/TotalPart_D.92f62da0a01b080e75d208661fd0beb0.svg";
export { ForwardRef as ReactComponent };